import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpinstance } from "../../axios/api";

// Async thunk for fetching airport data
export const getairport = createAsyncThunk("getairport", async (values, { rejectWithValue }) => {
    try {
        const url = `airline_airpots`;
        const response = await httpinstance.post(url, values);
        console.log(response);
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data || "Something went wrong");
    }
});
export const booking=createAsyncThunk('booking',async(values,{rejectWithValue})=>{
    console.log(values,"valuesredux");
    try{
        const url=`/booking`;
        const response=await httpinstance.post(url,values);
        return response;
    }catch(err){
        return rejectWithValue(err.response?.data || "Something went wrong") ;
    }
})
export const bookingupdate=createAsyncThunk('bookingupdate',async(values,{rejectWithValue})=>{
    try{
        const url=`/bookingUpdate`;
        const response=await httpinstance.post(url,values);
        return response;
    }catch(err){
        return rejectWithValue(err.response?.data || "Something went wrong") ;
    }
})
export const payment_verification=createAsyncThunk('payment_verification',async(values)=>{
    try{
        const url=`payment_verification`;
        const response=await httpinstance.post(url,values);
        return response;
    }catch(err){
        return err.response.data;
    }
})
export const remaining_balance_update=createAsyncThunk('remaining_balance_update',async(values)=>{
    try{
        const url=`remaining_balance_update`;
        const response=await httpinstance.put(url,values);
        return response;
    }catch(err){
        return err.response.data;
    }
})

export const getawb=createAsyncThunk('getawb',async(values)=>{
    try{
        // const url=`http://api.skyways-group.com/api/web/v1/freightsvs/014?token=015e6835b48ebadbdd7c29dad9cc8ad9`;
        const url=`awbgenerate`
        const response=await httpinstance.post(url,values);
        return response.data;
    }catch(err){
        return err;
    }
})

export const lattao=createAsyncThunk('lattao',async(values)=>{
    try{
        // const url=`http://api.skyways-group.com/api/web/v1/freightsvs/014?token=015e6835b48ebadbdd7c29dad9cc8ad9`;
        const url=`lat_tao`
        const response=await httpinstance.post(url,values);
        return response.data;
    }catch(err){
        return err.response.data.data;
    }
})
// Initial state
const initialState = {
    getairportname: [],
    bookingdata:{},
    verifypayment:{},
    bookingupdate:{},
    remaining_balance_update:{},
    awbdata:{},
    lattao:{},
    bookingid:{},
    // loading: false,
    // error: null,
};

// Create Slice
const airportSlice = createSlice({
    name: "airport",
    initialState,
    reducers: {
        clearState: (state) => {
            // Reset all state values to their initial state
            state.getairportname = [];
            state.bookingdata = {};
            state.verifypayment = {};
            state.bookingupdate = {};
            state.remaining_balance_update = {};
            state.awbdata = {};
            state.lattao = {};
            state.bookingid = {}; //
            state.loading = false;
            state.error = null;
        },
           setBookingdata: (state, action) => {
      state.bookingid = action.payload;
    },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getairport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getairport.fulfilled, (state, { payload }) => {
                state.getairportname = payload;
                state.loading = false;
            })
            .addCase(getairport.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            }).addCase(booking.fulfilled,(state,{payload})=>{
                state.bookingdata=payload
            }).addCase(booking.rejected,(state,{payload})=>{
                state.error=payload
            }).addCase(payment_verification.fulfilled,(state,{payload})=>{
                state.verifypayment=payload
            }).addCase(payment_verification.rejected,(state,{payload})=>{
                state.error=payload
            }).addCase(bookingupdate.fulfilled,(state,{payload})=>{
                state.bookingupdate=payload
            }).addCase(bookingupdate.rejected,(state,{payload})=>{
                state.error=payload
            }).addCase(remaining_balance_update.fulfilled,(state,{payload})=>{
                state.remaining_balance_update=payload
            }).addCase(remaining_balance_update.rejected,(state,{payload})=>{
                state.error=payload
            }).addCase(getawb.fulfilled,(state,{payload})=>{
                state.awbdata=payload
            }).addCase(getawb.rejected,(state,{payload})=>{
                state.error=payload
            }).addCase(lattao.fulfilled,(state,{payload})=>{
                state.lattao=payload
            }).addCase(lattao.rejected,(state,{payload})=>{
                state.error=payload
            })
    },
});

// Selectors


export const selectAirportData = (state) => state.airport.getairportname;
// export const selectAirportLoading = (state) => state.airport.loading;
// export const selectAirportError = (state) => state.airport.error;

// Export reducer
export const { clearState ,setBookingdata } = airportSlice.actions;
export const selectBookingId = (state) => state.airport.bookingid;

export default airportSlice.reducer;
